import { Carousel } from "primereact/carousel";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import LanguageContext from "../../components/Language/LanguageContext";

// Define interfaces for type safety
interface BannerItem {
  image: string;
  alt: string;
  title: string;
  description?: string;
}

interface LanguageContextType {
  language: string;
  messages: {
    Banner1Judul: string;
    Banner2Judul: string;
    Banner3Judul: string;
    ButtonGet: string;
    [key: string]: string;
  };
  changeLanguage: (lang: string) => void;
}

const Banner: React.FC = () => {
    const { language, messages, changeLanguage } = useContext(LanguageContext);
  
  const items: BannerItem[] = [
    {
      image: "/images/Banner/Banner3.png",
      alt: "Image 1",
      title: messages.Banner1Judul,
    },
    {
      image: "/images/Banner/Banner1.png",
      alt: "Image 2",
      title: messages.Banner2Judul,
    },
    {
      image: "/images/Banner/Banner2.png",
      alt: "Image 3",
      title: messages.Banner3Judul,
    },
  ];

  const itemTemplate = (item: BannerItem) => {
    const isLeftAligned = item.alt === "Image 1" || item.alt === "Image 3"; // Kondisi untuk gambar 1 dan 3
    const isRightAligned = item.alt === "Image 2"; // Kondisi untuk gambar 2

    return (
      <div
        className="carousel-banner"
        style={{ position: "relative", height: "570px", overflow: "hidden", marginTop:'70px' }}
        id="home">
        <img
          src={item.image}
          alt={item.alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            // opacity: 1, // Menambahkan opacity pada gambar
          }}
          className="imgBanner"
        />
        <div
          className="overlay"
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            display: "flex",
            flexDirection: "column",
            alignItems: isLeftAligned
              ? "flex-start"
              : isRightAligned
              ? "flex-end"
              : "center",
            justifyContent: "center",
            padding: "20px",
            textAlign: isLeftAligned
              ? "left"
              : isRightAligned
              ? "right"
              : "center",
          }}>
          <h3 className="overh3">{item.title}</h3>

          <p
            style={{
              color: "#fff",
              fontFamily: "Poppins",
              fontSize: "1.2rem",
              margin: "0",
              maxWidth: "800px",
              transform:
                isLeftAligned || isRightAligned ? "translateY(5px)" : "none",
              marginLeft: isLeftAligned ? "40px" : "0",
              marginRight: isRightAligned ? "40px" : "0", // Margin untuk gambar kedua
            }}>
            {item.description}
          </p>

          {isLeftAligned && item.alt !== "Image 3" && (
            <a href="https://app.smartsafetee.com/auth/login">
              <Button
                label={messages.ButtonGet}
                style={{
                  marginTop: "0px",
                  padding: "10px 20px",
                  fontSize: "1rem",
                  backgroundColor: "black",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  marginLeft: "10px",
                  fontFamily: "Poppins",
                }}
                className="buttonGet"
              />
            </a>
          )}
        </div>
      </div>
    );
  };

  return (
    <Carousel
      value={items}
      itemTemplate={itemTemplate}
      numVisible={1}
      numScroll={1}
      autoplayInterval={5000}
      circular={true}
      showIndicators={true}
      showNavigators={false}
      style={{ width: "100%", overflow: "hidden" }}
    />
  );
};

export default Banner;